import { Link } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import HeroCarousel from "./components/HeroCarousel";
import CategoryQuick from "./components/CategoryQuick";
import HotVideos from "./components/HotVideos";
import LatestStrip from "./components/LatestStrip";
import { getFeaturedVideos, getHotVideos, getLatestVideos } from "@/lib/videoData";
import { usePageMeta } from "@/hooks/usePageMeta";

const stats = [
  { value: "2.4亿", label: "日活跃用户", icon: "ri-group-line" },
  { value: "8600万", label: "创作者数量", icon: "ri-vidicon-line" },
  { value: "50+", label: "内容分类", icon: "ri-apps-2-line" },
  { value: "24小时", label: "不间断更新", icon: "ri-time-line" },
];

export default function Home() {
  usePageMeta({
    title: "快手短视频平台—热门短视频内容与创作社区",
    description:
      "快手提供丰富多样的短视频内容，涵盖生活、美食、娱乐等多个领域，用户可浏览、分享和创作精彩视频，体验互动社交乐趣。",
    keywords: "快手,短视频,短视频平台,视频分享,创作社区,热门视频,生活短视频,娱乐视频",
  });

  const featured = getFeaturedVideos(5);
  const hot = getHotVideos(8);
  const latest = getLatestVideos(10);

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />

      <main className="flex-1 pt-16">
        <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-6 md:py-8 space-y-14 md:space-y-16">
          <HeroCarousel items={featured} />
          <CategoryQuick />
          <HotVideos videos={hot} />
          <LatestStrip videos={latest} />

          <section className="w-full rounded-xl bg-gradient-to-br from-primary-500 to-primary-600 px-6 py-10 md:px-12 md:py-14">
            <div className="flex flex-col lg:flex-row lg:items-center gap-10">
              <div className="lg:w-1/2">
                <h2 className="text-2xl md:text-3xl font-bold text-background-50 leading-tight">
                  记录每一种生活
                  <br />
                  发现每一份热爱
                </h2>
                <p className="text-sm md:text-base text-background-50/85 mt-4 leading-relaxed max-w-lg">
                  快手是一个聚焦热门短视频内容与创作社区的综合短视频平台。无论你是喜欢刷视频的观众，还是热爱拍摄的创作者，都能在这里找到属于自己的舞台。
                </p>
                <div className="flex flex-wrap gap-3 mt-6">
                  <Link
                    to="/creator"
                    className="flex items-center gap-2 h-11 px-6 rounded-full bg-background-50 text-primary-600 text-sm font-medium hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-upload-2-line"></i>
                    成为创作者
                  </Link>
                  <Link
                    to="/about"
                    className="flex items-center gap-2 h-11 px-6 rounded-full border border-background-50/60 text-background-50 text-sm font-medium hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    了解更多
                  </Link>
                </div>
              </div>
              <div className="lg:w-1/2 grid grid-cols-2 gap-4">
                {stats.map((s) => (
                  <div key={s.label} className="rounded-lg bg-background-50/12 backdrop-blur px-5 py-5">
                    <span className="w-10 h-10 rounded-full bg-background-50/20 flex items-center justify-center text-background-50 text-xl mb-3">
                      <i className={s.icon}></i>
                    </span>
                    <p className="text-2xl font-bold text-background-50">{s.value}</p>
                    <p className="text-xs text-background-50/80 mt-1">{s.label}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </div>
      </main>

      <SiteFooter />
    </div>
  );
}